/* ============================================================
   LEWD FASHION — shared storefront util
   Asset: assets/lf-util.js   (brief §4.6 "shared formatting")

   ONE money(cents) + currency source imported by BOTH the cart
   drawer (assets/lf-cart-drawer.js) and the bundle section
   (assets/lf-lewk.js) so prices format identically everywhere.

   Currency is read from window.LF_CART_CONFIG.currency when the
   drawer snippet is present (site-wide), else defaults to '$'.
   ============================================================ */
(function () {
  'use strict';

  function currency() {
    var cfg = window.LF_CART_CONFIG;
    return (cfg && cfg.currency) ? cfg.currency : '$';
  }

  /* cents (integer, Shopify style) -> "$12.50" */
  function money(cents) {
    var n = Number(cents) || 0;
    return currency() + (n / 100).toFixed(2);
  }

  window.LFUtil = {
    money: money,
    currency: currency
  };
})();
